import React, { useState, useEffect } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { EnableBadge, DisableBadge, AddButton, CancelButton, SearchButton, SingleLink } from '../../Res/BaseButton';
import Swal from 'sweetalert2';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { uuid } from '../../../../item/ItemTools';
import { setResume2Token, getUserInfoCompanyId, getval2Token, setVal2Token } from '../../../Login/Auth';
import { api_getEmployeeResumeList } from '../../../../api/apiEmployeeResume';
import { api_getDepartmentList } from '../../../../api/apiCompany';
import { ReqEmployeeResumeList } from '../../../../item/ItemEmployeeResume';

export function EmployeeResumeList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [resumeList, setResumeList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)

    const [mReqEmployeeResumeList, setReqResumeList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqEmployeeResumeList = new ReqEmployeeResumeList({ companyId, start, limit })
            if (url === "") {
                toSearch({ items: mReqEmployeeResumeList, page: url.page })
            } else {
                mReqEmployeeResumeList.fromJson(url)
                toSearch({ items: mReqEmployeeResumeList, page: url.page })
            }
        }
    }, [id])

    // useEffect(()=>{
    //     if(Object.keys(mReqEmployeeResumeList).length !== 0){
    //         toSearch({items: mReqEmployeeResumeList})
    //     }
    // },[mReqEmployeeResumeList])

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqEmployeeResumeList = new ReqEmployeeResumeList({ companyId, start, limit })
        if (items !== undefined)
            mReqEmployeeResumeList.fromJson(items)
        mReqEmployeeResumeList.page = page
        setReqResumeList(mReqEmployeeResumeList)
        setVal2Token("url", mReqEmployeeResumeList, id)
        getResumeList(mReqEmployeeResumeList)
    }


    function getResumeList(mReqEmployeeResumeList) {
        setIsLoading(true)
        //console.log("mReqEmployeeResumeList")
        //console.log(mReqEmployeeResumeList)
        api_getEmployeeResumeList({
            mReqEmployeeResumeList,
            success: (obj) => {
                console.log(obj)
                setResumeList(obj.list)
                setCount(obj.count)
                setDisableCount(obj.disableCount)
                setEnableCount(obj.enableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/EmployeeResumeAdd");
    }


    var baseTitle = "員工列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"上工"} count={enableCount} />
                    <DisableBadge text={"下工"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                </div>
            </div>
            <div className="row m-b-sm">
            </div>
            <ResumeListBox resumeList={resumeList} srl={setResumeList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <ResumeListSearch action={toSearch} item={mReqEmployeeResumeList} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

function ResumeListSearch({ action, item }) {
    const [companyId] = useState(getUserInfoCompanyId())
    const [nickName, setNickName] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [jobStatus, setJobStatus] = useState("3")
    const [departmentId, setDepartmentId] = useState("")

    const [departmentList, setDepartmentList] = useState([])

    useEffect(()=>{
        setNickName(item.nickName===undefined?"":item.nickName)
        setIdNumber(item.idNumber===undefined?"":item.idNumber)
        setJobStatus(item.jobStatus===undefined?"":item.jobStatus)
        setDepartmentId(item.departmentId===undefined?"":item.departmentId)
        console.log(item)
    },[item])

    useEffect(() => {
        getDepartmentList()
    }, [])

    function getDepartmentList() {
        api_getDepartmentList({
            companyId,
            success: (jsonData) => {
                console.log(jsonData)
                setDepartmentList(jsonData.list)
                // if(jsonData.list.length > 0)
                //     setDepartmentId(jsonData.list[0].departmentId)
            },
            failure: (err) => {
            }
        })
    }

    function toClear() {
        setNickName("")
        setIdNumber("")
        setJobStatus("3")
        setDepartmentId("")
    }

    function toSearch() {
        var mReqEmployeeResumeList = new ReqEmployeeResumeList({
            nickName,
            idNumber,
            jobStatus,
            departmentId
        })
        action({ items: mReqEmployeeResumeList })
    }

    var content =
        <>
            <div className="row">
                <SingleInput title={"以姓名搜尋"} val={nickName} action={setNickName} size={4} />
                <SingleInput title={"身分證搜尋"} val={idNumber} action={setIdNumber} size={4} />
                <SingleSelect title={"上工狀態"}
                    val={"3"}
                    attr={[
                        /*{ "val": "1", "name": "全部" },
                        { "val": "2", "name": "上工" },*/
                        { "val": "3", "name": "下工" }
                    ]}
                    action={setJobStatus}
                    size={4}
                />
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <SingleSelect
                    title={"以部門搜尋"}
                    attr={departmentList}
                    val={departmentId}
                    v={'departmentId'}
                    n={'departmentName'}
                    action={setDepartmentId}
                    size={4}
                    hasBlank={true}
                />
            </div>



            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>
        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function ResumeListBox({ resumeList, srl, count, page, sp }) {
    const [mResumeList, setResumeList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (resumeList !== undefined && mResumeList !== resumeList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + resumeList.length)
            setResumeList(setTableList(resumeList))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [resumeList, count])

    function setTableList(resumeList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (resumeList[i] !== undefined) {
                list.push(<ResumeBox key={resumeList[i].accountId} resume={resumeList[i]} />)
            } else {
                list.push(<ResumeBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (mResumeList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">姓名</th>
                                    <th className="text-center sorting col-sm-2">年齡</th>
                                    <th className="text-center sorting col-sm-2">性別</th>
                                    <th className="text-center sorting col-sm-3">離職日</th>
                                    <th className="text-center sorting col-sm-2">狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mResumeList.map((resume) => (
                                        resume
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function ResumeBox({ resume }) {
    const [mResume, setResume] = useState({})
    const [mNickName, setNickName] = useState("")
    const [mAge, setAge] = useState("")
    const [mTokenId, setTokenId] = useState("")

    useEffect(() => {
        if (resume !== undefined && resume !== mResume) {
            setResume(resume)
            var tokenId = uuid(128, 64)
            setTokenId(tokenId)

            if (resume.nickName !== undefined && resume.nickName !== null) {
                setNickName(resume.nickName)
            } else {
                setNickName('N/A')
            }
            if (resume.birthday === "" || resume.birthday === undefined || resume.birthday === null) {
                setAge(" - ")
            } else {
                const startDate = moment(resume.birthday);
                const endDate = moment(new Date());
                const age = endDate.diff(startDate, 'years');
                setAge(age)
            }
        }
    }, [resume])

    function toResumeEdit() {
        setResume2Token(mResume.accountId, mTokenId)
        //window.location.assign("/EmployeeResumeDetail/" + mTokenId);
        window.open("/EmployeeResumeDetail/" + mTokenId, "_blank");
    }

    var sex = ""
    if (mResume.sex === "1") {
        sex = "男"
    } else if (mResume.sex === "2") {
        sex = "女"
    }

    var status = ""
    if (resume !== undefined) {
        status = <span className="text-danger">下工</span>
    }
    /*
    if (account.account_isDisable === 1) {
    status = <span className="text-danger">下工</span>
    } else {
    status = <span className="text-info">上工</span>
    }
    */

    return (
        <tr role="row">
            <td className="text-center"><SingleLink link={"EmployeeResumeDetail"} name={mNickName} Key={"accountId"} val={mResume.accountId}  ></SingleLink>&nbsp;</td>
            <td className="text-center">{mAge}</td>
            <td className="text-center">{sex}</td>
            <td className="text-center">-</td>
            <td className="text-center"><span>{status}</span></td>
        </tr>
    )
}
